import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { ButtonNewModule } from '../../common/button-new/button-new.module';
import { ButtonModule } from './../../common/button/button.module';
import { IconModule } from './../../common/icon/icon.module';
import { TooltipModule } from './../../common/tooltip/tooltip.module';
import { DialogCloseComponent } from './dialog-close.component';

@NgModule({
  imports: [CommonModule, ButtonModule, ButtonNewModule, TooltipModule, IconModule, I18nModule],
  declarations: [DialogCloseComponent],
  exports: [DialogCloseComponent],
})
export class DialogCloseModule {}
export { DialogCloseComponent } from './dialog-close.component';
